export default __webpack_public_path__ + "static/media/heart.d5a04001.svg";